import { PageSkeleton } from './Skeleton';

// Branded Ladezustand beim Tab-/Route-Wechsel · ersetzt das nackte "Loading...".
// Duenner, unbestimmter Accent-Balken oben (fuehlt sich schnell an) + dezentes
// Content-Skeleton, damit die Seite nicht leer flackert.

export function TopProgressBar() {
  return (
    <div className="fixed top-0 left-0 right-0 z-[70] h-0.5 overflow-hidden bg-accent/10 pointer-events-none">
      <div className="h-full w-1/3 bg-accent rounded-full animate-[indeterminate_1.1s_ease-in-out_infinite]" />
    </div>
  );
}

/** Suspense-Fallback fuer App-Routen · rendert innerhalb des Content-Bereichs (Sidebar bleibt). */
export function RouteFallback() {
  return (
    <>
      <TopProgressBar />
      <div className="mx-auto w-full max-w-6xl">
        <PageSkeleton />
      </div>
    </>
  );
}
